import React from "react";
import "../Guides/guides.css";
import Seo from "../Seo.jsx";
import mainConfig from "../../config/mainConfig";

const Privacy = () => {
  const meta = mainConfig.privacy?.seo || {};

  return (
    <div className="guides-content  guides-content-pad">
                   <Seo title={meta.title} description={meta.description} url={meta.route}/>

      <h1>Privacy Policy</h1>
  <p><strong>Last Updated:</strong> 4 Apr 2025</p>
  <p>
    This Privacy Policy applies to <strong>Matched Edge</strong>. We take your privacy seriously and are committed to protecting your personal information. This policy explains what data we collect, how we use it, and your rights regarding your personal data. By using our website, you agree to the terms outlined below.
  </p>

  <h2>1. Information We Collect</h2>

  <h3>Personal Information:</h3>
  <p>
    When you contact us via our contact form or email, we may collect your name, email address, and any other information you choose to provide.
  </p>

  <h3>Non-Personal Information:</h3>
  <p>
    We automatically collect certain information through cookies and similar technologies. This includes your IP address, browser type, device information, and browsing behavior on our site.
  </p>

  <h3>Website Usage Data:</h3>
  <p>
    Details of your visits, such as traffic data, location data, and website usage statistics, are collected using tools like Google Analytics. This data helps us understand how visitors interact with our site and improve our services.
  </p>

  <h2>2. How We Use Your Information</h2>
  <ul>
    <li><strong>To Provide Our Services:</strong> Responding to inquiries and delivering matched betting advice and related content.</li>
    <li><strong>To Improve Our Website:</strong> Enhancing user experience and tailoring our content based on how visitors use our site.</li>
    <li><strong>For Communication:</strong> Sending newsletters, updates, or promotional emails if you have subscribed to our mailing list.</li>
    <li><strong>Legal Compliance:</strong> Meeting our legal obligations and resolving disputes if necessary.</li>
    <li><strong>Analytics:</strong> Using aggregated, non-personal data to analyze trends and usage patterns.</li>
  </ul>

  <h2>3. Cookies and Analytics</h2>
  <p>We use cookies and similar tracking technologies to enhance your experience:</p>
  <ul>
    <li><strong>Essential Cookies:</strong> These are necessary for navigating our website and using its core features.</li>
    <li><strong>Performance Cookies:</strong> We use cookies to collect statistical information about your visit (e.g., which pages are visited most often). This data is anonymous and used solely to improve the website.</li>
    <li><strong>Functionality Cookies:</strong> These cookies help us remember your preferences (e.g., language or region) and provide a more personalized experience.</li>
    <li><strong>Analytics Tools:</strong> We use Google Analytics to understand visitor interactions. Google Analytics may collect data such as your IP address and browsing behavior.</li>
  </ul>
  <p>
    Third-party cookies (for example, those used by advertisers) may also be present. These cookies are managed by external providers and are subject to their own privacy policies. For more information on cookies, please visit 
    <a href="http://www.allaboutcookies.org" target="_blank" rel="noreferrer">www.allaboutcookies.org</a>.
  </p>

  <h2>4. Data Security</h2>
  <p>
    We take data security seriously and use SSL encryption, secure hosting, and other appropriate measures to safeguard your personal information. Access to personal data is restricted to authorized personnel only.
  </p>

  <h2>5. Your Rights</h2>
  <p>You have the right to:</p>
  <ul>
    <li><strong>Access:</strong> View the personal information we hold about you.</li>
    <li><strong>Update or Correct:</strong> Request corrections to any inaccurate or incomplete data.</li>
    <li><strong>Delete:</strong> Request the deletion of your personal information, subject to legal obligations.</li>
    <li><strong>Opt Out:</strong> Unsubscribe from our mailing list at any time by clicking the 'unsubscribe' link in our emails.</li>
  </ul>
  <p>
    To exercise your rights, please contact us at 
    <a href="mailto:matchededge@gmail.com">matchededge@gmail.com</a>.
  </p>

  <h2>6. Data Retention</h2>
  <p>
    We retain your personal data only for as long as necessary to provide you with our services or as required by law. Non-personally identifiable information may be kept for a longer period for analytics and research purposes.
  </p>

  <h2>7. Children's Privacy</h2>
  <p>
    Our website is not intended for children under the age of 18, and we do not knowingly collect personal information from children. If we become aware that we have inadvertently collected data from a child, we will take steps to delete it immediately.
  </p>

  <h2>8. Affiliate Links and Third-Party Disclosures</h2>
  <p>
    Our website may contain affiliate links and third-party advertisements. While we receive a small commission if you make a purchase through these links, your personal information will not be shared with advertisers or third parties without your consent, except as required by law.
  </p>
  <p>
    We are not responsible for the privacy practices of third-party websites. When you leave our site, please review their privacy policies.
  </p>

  <h2>9. Changes to This Policy</h2>
  <p>
    We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. Any updates will be posted on this page, and the “Last Updated” date at the top will be revised accordingly. We encourage you to review this policy periodically.
  </p>

  <h2>10. Contacting Us</h2>
  <p>
    If you have any questions, concerns, or requests regarding this Privacy Policy or our data practices, please contact us through our website or email us directly at 
    <a href="mailto:matchededge@gmail.com">matchededge@gmail.com</a>.
  </p>
  <p>
    By using our website, you acknowledge that you have read and understood this Privacy Policy and agree to its terms.
  </p>
    
    </div>
  );
};

export default Privacy;